<template>
  <header
    class="header"
    :class="[showNavBar ? '' : 'hide', addMenuBackground ? 'show-overlay' : '']"
  >
    <div class="logo">
      <img :src="logo" alt="GE Industrial Solutions" :class="[menuMobileIsOpen ? 'hide' : '']" />
      <img
        :src="logo_color"
        alt="GE Industrial Solutions"
        class="hide-desktop"
        :class="[!menuMobileIsOpen ? 'hide' : '']"
      />
    </div>

    <NavMenu class="hide-mobile" :data="menu" />

    <Social class="hide-mobile" :data="social" />
    <div class="menu-mobile hide-desktop" @click="openMenuMobileHandler()">
      <img src="@/assets/images/menu-mobile.svg" :class="[menuMobileIsOpen ? 'hide' : '']" alt />
      <img
        src="@/assets/images/menu-mobile-close.svg"
        :class="[!menuMobileIsOpen ? 'hide' : '']"
        alt
      />
    </div>
    <hr class="hide-desktop" :class="[menuMobileIsOpen ? 'change' : '']" />
    <div class="overlay-header" />

    <div
      class="menu-mobile-container hide-desktop"
      :class="[menuMobileIsOpen ? 'show' : '']"
      @click="openMenuMobileHandler()"
    >
      <NavMenu :data="menu" />
      <a href="tel:3232323232" class="btn-call">Llamanos</a>
      <div class="social-menu-mobile">
        <span>En las redes</span>
        <Social :data="social" />
      </div>
      <div class="rights-menu-mobile">
        © 2020 GE Industrial Solutions by ABB.
        <br />Todos los derechos reservados.
      </div>
    </div>
  </header>
</template>

<script>
export default {
  components: {
    NavMenu: () => import("../nav-menu/NavMenu"),
    Social: () => import("../social/Social"),
  },
  props: ["menu", "logo", "social", "logo_color"],
  data() {
    return {
      showNavBar: true,
      lastScrollPosition: 0,
      addMenuBackground: false,
      menuMobileIsOpen: false,
    };
  },
  methods: {
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollPosition < 0) return;
      if (currentScrollPosition > 0) {
        this.addMenuBackground = true;
      } else {
        this.addMenuBackground = false;
      }
      // this.showNavBar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
    openMenuMobileHandler() {
      this.menuMobileIsOpen = !this.menuMobileIsOpen;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>

<style lang="scss" src="./HeaderSite.scss" />